module.exports = __webpack_public_path__ + "img/04-3.234cdc2c.png";